import { IBlueBenefitsSubscription } from "../../../../../blue-benefits/models/subscriptions/blue-benefits-subscription.interface";
import { DialogResult } from "../../../../../dialog/dialog-enums";
import { IDotRezPersonComment } from "../../../../../dot-rez-api/data-contracts/user/person.data-contracts";
import { CompanionModel } from "../../../companion/companion.model";
import { IPersonViewModel } from "../../../person/person-view-model.interface";
import {IAuthorizedUserProfileDomain} from "./authorized-user-profile-domain.interface";
import {Price} from "../../../../../currency/price";
import {NullableNumber} from "../../../../../../types/nullable-types";

export class VoidAuthorizedUserProfileDomainModel implements IAuthorizedUserProfileDomain {

    readonly canAddCompanions: boolean = false;
    readonly shouldLoadBookingHistoryOnStartup: boolean = false;
    readonly organizationCredit: Price | null = null;
    readonly allowHoldBooking: boolean = false;
    async readCompanions(): Promise<CompanionModel[]> {
        return [];
    }
    async getBlueBenefitsSubscriptions(personComments: IDotRezPersonComment[]): Promise<IBlueBenefitsSubscription[]> {
        return [];
    }
    getCompanionsForBooking(): IPersonViewModel[] {
        return [];
    }
    async showContactInformationEditor(): Promise<DialogResult> {
        throw new Error("Not supported");
    }

    async updateOrganizationInfo(): Promise<void> {
    }

    getPsoTotalPaxOverride(options: any): NullableNumber {
        return null;
    }
}